/// <amd-module name="Artifacts/Pypi/PypiProtocol" />

import {
  createBadgeCommand,
  createDeleteCommand,
  createGetLinkCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
  createUpstreamOverrideCommand,
} from "Artifacts/Pypi/commands";
import { logoContributionId } from "Artifacts/Pypi/components/Logo";
import { PypiAttributes } from "Artifacts/Pypi/components/PypiPackageAttributes";
import { PypiOverview } from "Artifacts/Pypi/components/PypiPackageOverview";
import { PypiModule } from "Artifacts/Pypi/redux";
import { IFeedPyPiDataService } from "Artifacts/Pypi/services/PyPiDataService";
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { UpstreamVersionVisibility } from "Artifacts/Root/types/PackagingShared";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class PypiProtocol implements IProtocol {
  public readonly id = Protocol.Pypi;
  public readonly name = "Python";
  public readonly statusUrl = "https://status.python.org/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createPromoteCommand(pageContext, versions),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createDeleteCommand(pageContext, versions, feed),
      createBadgeCommand(pageContext, versions, feed),
      createUpstreamOverrideCommand(pageContext),
      createGetLinkCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];

    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return PypiOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return PypiAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return PypiModule;
  }

  public async getUpstreamOverrideStatus(
    pageContext: IVssPageContext,
    packageName: string,
    feed?: IFeed,
  ): Promise<boolean> {
    if (!feed) {
      return false;
    }
    const dataService = pageContext.getService<IFeedPyPiDataService>("IFeedPyPiDataService");
    const overrideBehavior = await dataService.getUpstreamingBehavior(
      feed?.id,
      packageName,
      feed?.project?.id,
    );
    return (
      overrideBehavior?.versionsFromExternalUpstreams ===
      UpstreamVersionVisibility.AllowExternalVersions
    );
  }

  public getUpstreamingProperties(_pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: true,
      isAadUpstreamsSupported: true,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }
}

ProtocolService.registerProtocol(new PypiProtocol());
